// // import {
// //   axios,
// //   config,
// //   LOGINAUTH,
// //   LOGOUT,
// //   LOGINULL,
// //   baseURL,
// //   CREATEUSER,
// //   UPDATEUSER,
// //   GETUSERBYROLL,
// //   UPDATEUSERBYMOBAIL,
// //   DELETEUSER,
// //   GET_ALL_USERS
// // } from './types';


// // export const handleloginnull = (value) => {
// //   console.log(value)
// //   return {
// //     type: LOGINULL,
// //     payload: value,
// //   }
// // }
// // export const handlelogin = (mobile, password) => dispatch => {
// //   const loginObject = { mobile, password };

// //   const config = {
// //     method: 'post',
// //     url: `${baseURL}/api/appointmentUser/login`,
// //     headers: { 'Content-Type': 'application/json' },
// //     data: loginObject,
// //   };

// //   return axios(config)
// //     .then(response => {
// //       const loginData = response.data;
// //       localStorage.setItem('loginData', JSON.stringify(loginData.data));
// //       console.log(loginData)
// //       dispatch({
// //         type: LOGINAUTH,
// //         payload: loginData,
// //       });

// //       return { success: true, data: loginData };
// //     })
// //     .catch(error => {
// //       console.error('Login error:', error?.response?.data || error.message);
// //       return {
// //         success: false,
// //         message: error?.response?.data?.message || 'Incorrect Mobile or Password',
// //       };
// //     });
// // };

// // // return axios.post("api/users/login", loginObject, config).then(res => {
// // //     console.log(res)
// // //     dispatch({
// // //         type: LOGINAUTH,
// // //         payload: res.data
// // //     })
// // // })
// // // export const handlelogin = (mobile, password) => (dispatch) => {
// // //   const loginObject = { mobile, password };

// // //   const config = {
// // //     method: 'post',
// // //     url: `${baseURL}/api/users/login`,
// // //     headers: {
// // //       'Content-Type': 'application/json',
// // //     },
// // //     data: loginObject,
// // //   };

// // //   return axios(config)
// // //     .then((response) => {
// // //       const { username, token } = response.data.data; // Ensure username is extracted correctly
// // //       console.log("login payload:", { username});
// // //       localStorage.setItem('userName', username);  // Store username
// // //       // localStorage.setItem('authToken', token);   // Store auth token

// // //       // Dispatch the username and token as part of the payload
// // //       dispatch({
// // //         type: LOGINAUTH,
// // //         payload: { username },  // Make sure username and token are in the payload
// // //       });
// // //     })
// // //     .catch((error) => {
// // //       console.error('Login failed:', error.response?.data?.error || error.message);
// // //     });
// // // };

// // // actionTypes.js (if you use constants)

// // // authActions.js


// // export const userRegister = (userData) => async (dispatch) => {
// //   const config = {
// //     method: 'post',
// //     url: `${baseURL}/api/appointmentUser/create`,
// //     headers: {
// //       'Content-Type': 'application/json',
// //     },
// //     data: userData,
// //   };

// //   console.log("Register payload:", userData);

// //   try {
// //     const response = await axios(config);

// //     dispatch({
// //       type: CREATEUSER,
// //       payload: response.data,
// //     });

// //     return {
// //       success: 1,
// //       message: "Registration successful",
// //       data: response.data,
// //     };
// //   } catch (error) {
// //     console.error("Registration failed:", error.response?.data || error.message);

// //     return {
// //       success: 0,
// //       message: error.response?.data?.message || "Registration failed.",
// //     };
// //   }
// // };

// // // export const updateUser = (UserData) => dispatch => {
// // //   var config = {
// // //     method: 'patch',
// // //     url: baseURL + '/api/appointmentUser/update',
// // //     headers: {
// // //       "Authorization": `Bearer ${localStorage.getItem('token')}`,
// // //       'Content-Type': 'application/json'
// // //     },
// // //     data: UserData
// // //   };

// // //   axios(config)
// // //     .then(function (response) {
// // //       dispatch({
// // //         type: UPDATEUSER,
// // //         payload: response.data
// // //       })
// // //     })
// // //     .catch(function (error) {
// // //       console.log(error);
// // //     });

// // // }

// // // In loginAction.js - check your updateUser function
// // // export const updateUser = (userData) => async (dispatch) => {
// // //   try {
// // //     // Make sure token is preserved in the request if needed
// // //     const token = localStorage.getItem('token');
    
// // //     const response = await axios.patch(
// // //       `${baseURL}/api/appointmentUser/update`,
// // //       userData,
// // //       {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           Authorization: token ? `Bearer ${token}` : ''
// // //         }
// // //       }
// // //     );
    
// // //     // After successful update, update localStorage but KEEP THE TOKEN
// // //     if (response.data.success) {
// // //       const currentLoginData = JSON.parse(localStorage.getItem('loginData') || '{}');
// // //       const updatedData = {
// // //         ...currentLoginData,
// // //         ...userData,
// // //         token: currentLoginData.token || token // Preserve token
// // //       };
// // //       localStorage.setItem('loginData', JSON.stringify(updatedData));
// // //     }
    
// // //     return response.data;
// // //   } catch (error) {
// // //     console.error('Update user error:', error);
// // //     throw error;
// // //   }
// // // };
// // export const updateUser = (userData) => async (dispatch) => {
// //   try {
// //     const token = localStorage.getItem('token');
    
// //     const response = await axios.patch(
// //       `${baseURL}/api/appointmentUser/update`,
// //       userData,
// //       {
// //         headers: {
// //           'Content-Type': 'application/json',
// //           Authorization: token ? `Bearer ${token}` : ''
// //         }
// //       }
// //     );
    
    
// //     if (response.data.success) {
// //       const currentLoginData = JSON.parse(localStorage.getItem('loginData') || '{}');

      
// //       if (currentLoginData.hospitalID === userData.hospitalID) {
// //         const updatedData = {
// //           ...currentLoginData,
// //           ...userData,
// //           token: currentLoginData.token || token
// //         };
// //         localStorage.setItem('loginData', JSON.stringify(updatedData));
// //         console.log("Self profile updated in localStorage");
// //       } else {

// //         console.log("Other user updated, skipping localStorage changes");
// //       }

// //       dispatch({
// //         type: UPDATEUSER,
// //         payload: response.data
// //       });
// //     }
    
// //     return response.data;
// //   } catch (error) {
// //     console.error('Update user error:', error);
// //     throw error;
// //   }
// // };
// // export const updateUser1 = (UserData) => dispatch => {
// //   var config = {
// //     method: 'patch',
// //     url: baseURL + '/api/users/updatebymobail',
// //     headers: {
// //       "Authorization": `Bearer ${localStorage.getItem('token')}`,
// //       'Content-Type': 'application/json'
// //     },
// //     data: UserData
// //   };

// //   axios(config)
// //     .then(function (response) {
// //       dispatch({
// //         type: UPDATEUSERBYMOBAIL,
// //         payload: response.data
// //       })
// //     })
// //     .catch(function (error) {
// //       console.log(error);
// //     });

// // }
// // // loginAction.js mein ye add karein
// // export const resetPasswordByMobile = (mobile, newPassword) => async (dispatch) => {
// //   const updateData = {
// //     mobile: mobile,
// //     password: newPassword // Backend matches by mobile and updates this password
// //   };

// //   const config = {
// //     method: 'patch',
// //     url: `${baseURL}/api/appointmentUser/update`, // Aapka bataya hua endpoint
// //     headers: { 'Content-Type': 'application/json' },
// //     data: updateData,
// //   };

// //   try {
// //     const response = await axios(config);
// //     return { success: true, message: "Password updated successfully!" };
// //   } catch (error) {
// //     console.error("Reset password error:", error);
// //     return { 
// //       success: false, 
// //       message: error.response?.data?.message || "Failed to update password" 
// //     };
// //   }
// // };
// // export const getUserById = async (HospitalId) => {
// //   try {
// //     const token = localStorage.getItem('token');
// //     const config = {
// //       headers: {
// //         'Content-Type': 'application/json',
// //         Authorization: `Bearer ${token}`,
// //       },
// //     };
    
// //     const response = await axios.post(
// //       `${baseURL}/api/appointmentUser/byid`,
// //     {"hospitalID":HospitalId
// //     },
// //       config
      
// //     );
    
// //     if (response.data.success) {
// //       console.log(response.data.data.subscription_status)
// //       return response.data.data.subscription_status
// //     }
// //     return null;
// //   } catch (error) {
// //     console.error("Error fetching video sessions:", error);
// //     return null;
// //   }
// // };

// // export const getAllUsers = (hospitalID) => (dispatch) => {
// //   const token = localStorage.getItem('token');
// //   const config = {
// //     method: 'post',
// //     url: `${baseURL}/api/appointmentUser/getall`,
// //     headers: {
// //       'Content-Type': 'application/json',
// //       ...(token && { 'Authorization': `Bearer ${token}` }),
// //     },
// //     data: {hospitalID},
// //   };

// //   console.log("Fetching all users with config:", config);

// //   return axios(config)
// //     .then((response) => {
// //       dispatch({
// //         type: GET_ALL_USERS,
// //         payload: response.data,
// //       });
// //     })
// //     .catch((error) => {
// //       console.error("Fetching users failed:", error.response?.data || error.message);
// //     });
// // };

// // export const getUserbyroll = (UserData) => dispatch => {

// //   var config = {
// //     method: 'post',
// //     // url: baseURL+'/api/users/userrole',
// //     url: baseURL + '/api/users/getallbyroll',
// //     headers: {
// //       "Authorization": `Bearer ${localStorage.getItem('token')}`,
// //       'Content-Type': 'application/json'
// //     },
// //     data: UserData
// //   };

// //   axios(config)
// //     .then(function (response) {
// //       console.log(JSON.stringify(response.data))
// //       dispatch({
// //         type: GETUSERBYROLL,
// //         payload: response.data
// //       })
// //     })
// //     .catch(function (error) {
// //       console.log(error);
// //     });

// // }

// // export const deleteUser = (data) => (dispatch) => {
// //   var config = {
// //     method: "delete",
// //     url: baseURL + "/api/users/delete",
// //     headers: {
// //       Authorization: `Bearer ${localStorage.getItem("token")}`,
// //       "Content-Type": "application/json",
// //     },
// //     data: data,
// //   };

// //   axios(config)
// //     .then(function (response) {
// //       dispatch({
// //         type: DELETEUSER,
// //         payload: response.data,
// //       });
// //     })
// //     .catch(function (error) {
// //       console.log(error);
// //     });
// // };



// // export const logout = () => (dispatch) => {
// //   console.log('Dispatching robust logout action...');
  
// //   // 1. Clear all authentication data from localStorage
// //   localStorage.removeItem('loginData');
// //   localStorage.removeItem('token');
// //   localStorage.removeItem('hospitalCode');
// //   localStorage.removeItem('redirectAfterLogin')
// //   localStorage.removeItem('StaffRole')
// //   localStorage.removeItem('selectedCurrency');

// //   // Also clear the hospitalCode
// //   // Add any other localStorage items you set on login

// //   // 2. Dispatch the LOGOUT action to reset the entire Redux authentication state
// //   dispatch({
// //     type: 'LOGOUT' // This action type needs to be handled by your reducer
// //   });  
// //   // 3. THE FIX: Force a full page reload to the root URL.
// //   // This will clear the hash from the URL and ensure a clean state for the entire app.
// //   // The '#' character tells the HashRouter to go to its root path.
// //   window.location.href = '/#/'; 

// //   // Why '/#/'?
// //   // The first '/' tells the browser to go to the root of the domain (e.g., http://localhost:3000).
// //   // The '/#/' part then tells the HashRouter to go to its base route.
// //   // This combination is very effective for cleaning up the URL.
// // };

















// import {
//     axios,
//     config,
//     LOGINAUTH,
//     LOGOUT,
//     LOGINULL,
//     baseURL,
//     CREATEUSER,
//     UPDATEUSER,
//     GETUSERBYROLL,
//     UPDATEUSERBYMOBAIL,
//     DELETEUSER,
//     GET_ALL_USERS
// } from './types';

// // ============================================================
// // LOGIN ACTION
// // Flow (image ke hisaab se):
// //   Step 1: Login API call karo
// //   Step 2: Role check karo (Admin / Patient / SuperAdmin)
// //   Step 3: Agar Admin hai → app_status check karo
// //   Step 4: app_status === 'disabled' → error return karo
// //   Step 5: Login allow karo → subscription_status localStorage mein save karo
// // ============================================================

// export const handleloginnull = (value) => {
//     return {
//         type: LOGINULL,
//         payload: value,
//     };
// };

// // ✅ MAIN LOGIN ACTION — image ka poora flow yahan implement hai
// // export const handlelogin = (mobile, password) => dispatch => {
// //     const loginObject = { mobile, password };

// //     const config = {
// //         method: 'post',
// //         url: `${baseURL}/api/appointmentUser/login`,
// //         headers: { 'Content-Type': 'application/json' },
// //         data: loginObject,
// //     };

// //     return axios(config)
// //         .then(response => {
// //             const loginData = response.data;
// //             const userData = loginData.data;

// //             console.log('[Login] Response received:', userData);

// //             // ─── Step 2: Role Check ───────────────────────────────────
// //             // image mein: Role Check → Admin ya Patient/SuperAdmin
// //             const role = userData?.role;
// //             console.log('[Login] Role:', role);

// //             // ─── Step 3: app_status Check (sirf Admin ke liye) ────────
// //             // image mein: Admin → Check app_status → disabled → block
// //             if (role === 'Admin') {
// //                 const appStatus = userData?.app_status;
// //                 console.log('[Login] app_status:', appStatus);

// //                 if (appStatus === 'disabled') {
// //                     // ─── Step 4: Block karo ──────────────────────────
// //                     // image mein box 4: "Your account is disabled"
// //                     console.log('[Login] Account disabled — blocking login');
// //                     return {
// //                         success: false,
// //                         message: 'Your account has been disabled by an administrator. Please contact admin to activate your account.',
// //                     };
// //                 }
// //             }

// //             // ─── Step 5: Login Allow karo ─────────────────────────────
// //             // image mein box 5: "Login Allowed"

// //             // subscription_status bhi localStorage mein save karo
// //             // ye sidebar aur App.js use karenge
// //             const dataToSave = {
// //                 ...userData,
// //                 // Ensure ye fields hamesha hain
// //                 subscription_status: userData.subscription_status || null,
// //                 Subscription_type: userData.Subscription_type || null,
// //                 app_status: userData.app_status || 'enabled',
// //             };

// //             localStorage.setItem('loginData', JSON.stringify(dataToSave));
// //             console.log('[Login] loginData saved to localStorage:', dataToSave);

// //             // Redux mein dispatch karo
// //             dispatch({
// //                 type: LOGINAUTH,
// //                 payload: {
// //                     ...loginData,
// //                     data: dataToSave,
// //                 },
// //             });

// //             return { success: true, data: loginData };
// //         })
// //         .catch(error => {
// //             console.error('[Login] Error:', error?.response?.data || error.message);
// //             return {
// //                 success: false,
// //                 message: error?.response?.data?.message || 'Incorrect Mobile or Password',
// //             };
// //         });
// // };
// // loginAction.js mein handlelogin function
// // loginAction.js - REPLACE your handlelogin function with this

// export const handlelogin = (mobile, password) => dispatch => {
//     const loginObject = { mobile, password };

//     return axios.post(`${baseURL}/api/appointmentUser/login`, loginObject)
//         .then(response => {
//             const loginData = response.data;
//             const userData = loginData.data;

//             // ✅ CRITICAL: Force read subscription_status
//             // Agar API se null aaya, toh localStorage se le lo
//             let subscriptionStatus = userData.subscription_status;
//             let subscriptionType = userData.Subscription_type;
            
//             console.log('[Login] API returned subscription_status:', subscriptionStatus);
            
//             // Agar API se null hai, toh DB se direct fetch karo
//             if (!subscriptionStatus || subscriptionStatus === 'null') {
//                 // Try to get from localStorage first
//                 const existingData = localStorage.getItem('loginData');
//                 if (existingData) {
//                     const parsed = JSON.parse(existingData);
//                     subscriptionStatus = parsed.subscription_status;
//                     subscriptionType = parsed.Subscription_type;
//                     console.log('[Login] Using localStorage subscription:', subscriptionStatus);
//                 }
                
//                 // Agar localStorage mein bhi nahi hai, toh 'inactive' set karo
//                 if (!subscriptionStatus) {
//                     subscriptionStatus = 'inactive';
//                     subscriptionType = null;
//                     console.log('[Login] Using default: inactive');
//                 }
//             }

//             const dataToSave = {
//                 ...userData,
//                 subscription_status: subscriptionStatus,
//                 Subscription_type: subscriptionType,
//                 app_status: userData.app_status || 'enabled',
//             };

//             console.log('[LoginAction] FINAL dataToSave:', {
//                 subscription_status: dataToSave.subscription_status,
//                 Subscription_type: dataToSave.Subscription_type
//             });

//             localStorage.setItem('loginData', JSON.stringify(dataToSave));

//             // ✅ IMPORTANT: Dispatch with correct structure
//             dispatch({
//                 type: LOGINAUTH,
//                 payload: {
//                     success: 1,
//                     data: dataToSave
//                 }
//             });

//             return { success: true, data: loginData };
//         })
//         .catch(error => {
//             console.error('[LoginAction] Error:', error);
//             return { success: false, message: error?.response?.data?.message || 'Login failed' };
//         });
// };
// // ✅ YE NAI ACTION HAI — Plan purchase ke baad subscription update karo
// // PlanSelection.js is action ko dispatch karega
// export const updateSubscriptionStatus = (subscriptionStatus, subscriptionType) => dispatch => {
//     console.log('[Subscription] Updating status:', subscriptionStatus, subscriptionType);

//     // 1. localStorage update karo
//     const savedData = localStorage.getItem('loginData');
//     if (savedData) {
//         const loginData = JSON.parse(savedData);
//         loginData.subscription_status = subscriptionStatus;
//         loginData.Subscription_type = subscriptionType;
//         localStorage.setItem('loginData', JSON.stringify(loginData));
//         console.log('[Subscription] localStorage updated');
//     }

//     // 2. Redux store update karo
//     dispatch({
//         type: 'UPDATE_SUBSCRIPTION_STATUS',
//         payload: {
//             subscriptionStatus: subscriptionStatus,
//             subscriptionType: subscriptionType,
//         },
//     });
// };

// // ─── Baaki existing functions same rahenge ────────────────────────────────────

// export const userRegister = (userData) => async (dispatch) => {
//     const config = {
//         method: 'post',
//         url: `${baseURL}/api/appointmentUser/create`,
//         headers: { 'Content-Type': 'application/json' },
//         data: userData,
//     };

//     try {
//         const response = await axios(config);
//         dispatch({ type: CREATEUSER, payload: response.data });
//         return { success: 1, message: "Registration successful", data: response.data };
//     } catch (error) {
//         return { success: 0, message: error.response?.data?.message || "Registration failed." };
//     }
// };

// export const updateUser = (userData) => async (dispatch) => {
//     try {
//         const token = localStorage.getItem('token');
//         const response = await axios.patch(
//             `${baseURL}/api/appointmentUser/update`,
//             userData,
//             { headers: { 'Content-Type': 'application/json', Authorization: token ? `Bearer ${token}` : '' } }
//         );

//         if (response.data.success) {
//             const currentLoginData = JSON.parse(localStorage.getItem('loginData') || '{}');
//             if (currentLoginData.hospitalID === userData.hospitalID) {
//                 const updatedData = {
//                     ...currentLoginData,
//                     ...userData,
//                     token: currentLoginData.token || token
//                 };
//                 localStorage.setItem('loginData', JSON.stringify(updatedData));
//             }
//             dispatch({ type: UPDATEUSER, payload: response.data });
//         }

//         return response.data;
//     } catch (error) {
//         console.error('Update user error:', error);
//         throw error;
//     }
// };

// export const updateUser1 = (UserData) => dispatch => {
//     var config = {
//         method: 'patch',
//         url: baseURL + '/api/users/updatebymobail',
//         headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
//         data: UserData
//     };
//     axios(config)
//         .then(response => dispatch({ type: UPDATEUSERBYMOBAIL, payload: response.data }))
//         .catch(error => console.log(error));
// };

// export const resetPasswordByMobile = (mobile, newPassword) => async (dispatch) => {
//     const updateData = { mobile, password: newPassword };
//     const config = {
//         method: 'patch',
//         url: `${baseURL}/api/appointmentUser/update`,
//         headers: { 'Content-Type': 'application/json' },
//         data: updateData,
//     };
//     try {
//         await axios(config);
//         return { success: true, message: "Password updated successfully!" };
//     } catch (error) {
//         return { success: false, message: error.response?.data?.message || "Failed to update password" };
//     }
// };

// export const getUserById = async (HospitalId) => {
//     try {
//         const token = localStorage.getItem('token');
//         const response = await axios.post(
//             `${baseURL}/api/appointmentUser/byid`,
//             { hospitalID: HospitalId },
//             { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
//         );
//         if (response.data.success) return response.data.data.subscription_status;
//         return null;
//     } catch (error) {
//         return null;
//     }
// };

// export const getAllUsers = (hospitalID) => (dispatch) => {
//     const token = localStorage.getItem('token');
//     const config = {
//         method: 'post',
//         url: `${baseURL}/api/appointmentUser/getall`,
//         headers: { 'Content-Type': 'application/json', ...(token && { 'Authorization': `Bearer ${token}` }) },
//         data: { hospitalID },
//     };
//     return axios(config)
//         .then(response => dispatch({ type: GET_ALL_USERS, payload: response.data }))
//         .catch(error => console.error("Fetching users failed:", error.response?.data || error.message));
// };

// export const getUserbyroll = (UserData) => dispatch => {
//     var config = {
//         method: 'post',
//         url: baseURL + '/api/users/getallbyroll',
//         headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
//         data: UserData
//     };
//     axios(config)
//         .then(response => dispatch({ type: GETUSERBYROLL, payload: response.data }))
//         .catch(error => console.log(error));
// };

// export const deleteUser = (data) => (dispatch) => {
//     var config = {
//         method: "delete",
//         url: baseURL + "/api/users/delete",
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" },
//         data: data,
//     };
//     axios(config)
//         .then(response => dispatch({ type: DELETEUSER, payload: response.data }))
//         .catch(error => console.log(error));
// };

// export const logout = () => (dispatch) => {
//     console.log('[Logout] Clearing all data...');
//     localStorage.removeItem('loginData');
//     localStorage.removeItem('token');
//     localStorage.removeItem('hospitalCode');
//     localStorage.removeItem('redirectAfterLogin');
//     localStorage.removeItem('StaffRole');
//     localStorage.removeItem('selectedCurrency');

//     dispatch({ type: 'LOGOUT' });
//     window.location.href = '/#/';
// };

// // React Native ke liye
// export const handleClearState = () => (dispatch) => {
//     dispatch({ type: LOGINULL, payload: 0 });
// };






























// loginAction.js - COMPLETE NEW VERSION

import {
    axios,
    LOGINAUTH,
    LOGOUT,
    LOGINULL,
    baseURL,
    CREATEUSER,
    UPDATEUSER,
    GETUSERBYROLL,
    UPDATEUSERBYMOBAIL,
    DELETEUSER,
    GET_ALL_USERS,
   GENERATE_CAPTCHA_SUCCESS,   // ✅ add karo
    GENERATE_CAPTCHA_ERROR   
} from './types';

// ============================================================
// HELPER FUNCTION: Parse Date (DD-MM-YYYY)
// ============================================================
const parseDate = (dateString) => {
    if (!dateString) return null;
    try {
        const parts = dateString.split('-');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            return new Date(year, month, day);
        }
    } catch (error) {
        console.error('[parseDate] Error:', error);
    }
    return null;
};
// loginAction.js - Fix the generateCaptcha function

export const generateCaptcha = () => async (dispatch) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${baseURL}/api/captcha/generate`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` })
                }
            }
        );

        console.log("[generateCaptcha] Full API Response:", response.data);

        if (response.data && response.data.success === 1) {
            // ✅ Fix: Map the response correctly
            dispatch({
                type: GENERATE_CAPTCHA_SUCCESS,
                payload: {
                    captchaImage: response.data.captchaImage,  // ✅ Use captchaImage
                    captchaUuid: response.data.captchaUuid     // ✅ Use captchaUuid
                }
            });
            return response.data;
        } else {
            console.error("[generateCaptcha] API returned success !== 1");
            dispatch({ type: GENERATE_CAPTCHA_ERROR });
            return null;
        }
    } catch (error) {
        console.error('[generateCaptcha] Error:', error);
        dispatch({ type: GENERATE_CAPTCHA_ERROR });
        return null;
    }
};
// export const generateCaptcha = () => async (dispatch) => {
//     try {
//         const token = localStorage.getItem('token');
//         const response = await axios.post(
//             `${baseURL}/api/captcha/generate`,
//             {},
//             {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     ...(token && { Authorization: `Bearer ${token}` })
//                 }
//             }
//         );

//         if (response.data) {
//             dispatch({
//                 type: GENERATE_CAPTCHA_SUCCESS,
//                 payload: response.data  // { image: 'base64...', captchaId: '...' }
//             });
//             return response.data;
//         }
//     } catch (error) {
//         console.error('[generateCaptcha] Error:', error);
//         dispatch({ type: GENERATE_CAPTCHA_ERROR });
//         return null;
//     }
// };
// ============================================================
// HELPER FUNCTION: Check Active Plan from Business Modules
// ============================================================
const checkActivePlan = (businessModules, hospitalID) => {
    if (!businessModules || !Array.isArray(businessModules) || businessModules.length === 0) {
        console.log('[checkActivePlan] No business modules found');
        return null;
    }
    
    const today = new Date();
    const userModules = businessModules.filter(module => module.hospitalID === parseInt(hospitalID));
    
    console.log('[checkActivePlan] User modules:', userModules.length);
    
    const activePlans = userModules.filter(plan => {
        // Sirf subscription ya commission type check karo
        if (!plan.businessType || (plan.businessType !== 'subscription' && plan.businessType !== 'commission')) {
            return false;
        }
        
        // Commission plan (no expiry)
        if (plan.businessType === 'commission' && !plan.valid_To) {
            console.log('[checkActivePlan] Active commission plan found:', plan);
            return true;
        }
        
        // Subscription plan with expiry date
        if (plan.valid_To) {
            const validToDate = parseDate(plan.valid_To);
            if (validToDate && validToDate > today) {
                console.log('[checkActivePlan] Active subscription plan found:', {
                    id: plan.id,
                    valid_To: plan.valid_To
                });
                return true;
            }
        }
        
        return false;
    });
    
    if (activePlans.length > 0) {
        // Return most recent active plan
        return activePlans.sort((a, b) => b.id - a.id)[0];
    }
    
    console.log('[checkActivePlan] No active plan found');
    return null;
};

// ============================================================
// HELPER FUNCTION: Fetch Business Modules from API
// ============================================================
const fetchBusinessModules = async (hospitalID, token) => {
    try {
        console.log('[fetchBusinessModules] Fetching for hospitalID:', hospitalID);
        
        const response = await axios.post(
            `${baseURL}/api/appointmentBusinessModules/getAll`,
            { hospitalID: parseInt(hospitalID) },
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
        );
        
        if (response.data?.success && Array.isArray(response.data.data)) {
            console.log('[fetchBusinessModules] Found:', response.data.data.length, 'modules');
            return response.data.data;
        }
        
        return [];
    } catch (error) {
        console.error('[fetchBusinessModules] Error:', error);
        return [];
    }
};

// ============================================================
// HELPER FUNCTION: Sync User Subscription
// ============================================================
const syncUserSubscription = async (userData, activePlan, token, dispatch) => {
    try {
        let subscriptionStatus = 'inactive';
        let subscriptionType = null;
        
        if (activePlan) {
            subscriptionStatus = 'active';
            subscriptionType = activePlan.businessType;
            console.log('[syncUserSubscription] Active plan found:', { subscriptionStatus, subscriptionType });
        } else {
            console.log('[syncUserSubscription] No active plan, setting inactive');
        }
        
        // Prepare update payload
        const updatePayload = {
            hospitalID: parseInt(userData.hospitalID),
            username: userData.username,
            password: userData.password || "123",
            first_name: userData.first_name || "",
            last_name: userData.last_name || "",
            email: userData.email || "",
            role: userData.role || "Admin",
            mobile: userData.mobile,
            app_status: "enabled",
            subscription_status: subscriptionStatus,
            Subscription_type: subscriptionType,
        };
        
        console.log('[syncUserSubscription] Updating user with payload:', updatePayload);
        
        // Update user via API
        const response = await axios.patch(
            `${baseURL}/api/appointmentUser/update`,
            updatePayload,
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
        );
        
        if (response.data?.success) {
            console.log('[syncUserSubscription] User updated successfully');
            
            // Update localStorage
            const updatedLoginData = {
                ...userData,
                subscription_status: subscriptionStatus,
                Subscription_type: subscriptionType,
            };
            localStorage.setItem('loginData', JSON.stringify(updatedLoginData));
            
            // Update Redux
            dispatch({
                type: 'UPDATE_SUBSCRIPTION_STATUS',
                payload: {
                    subscriptionStatus: subscriptionStatus,
                    subscriptionType: subscriptionType,
                },
            });
            
            return true;
        }
        
        return false;
    } catch (error) {
        console.error('[syncUserSubscription] Error:', error);
        return false;
    }
};

// ============================================================
// MAIN LOGIN ACTION
// ============================================================
export const handleloginnull = (value) => {
    return {
        type: LOGINULL,
        payload: value,
    };
};

// export const handlelogin = (mobile, password) => async (dispatch) => {
//     const loginObject = { mobile, password };

//     try {
//         // Step 1: Login API Call
//         const loginResponse = await axios.post(`${baseURL}/api/appointmentUser/login`, loginObject);
//         const loginData = loginResponse.data;
//         const userData = loginData.data;
        
//         console.log('[Login] User logged in:', { role: userData.role, hospitalID: userData.hospitalID });
        
//         // Step 2: Role Check - Sirf Admin ke liye subscription check
//         const token = userData.token;
//         const hospitalID = userData.hospitalID;
//         const role = userData.role;
        
//         let activePlan = null;
//         let subscriptionStatus = userData.subscription_status || 'inactive';
//         let subscriptionType = userData.Subscription_type || null;
        
//         // Step 3: Sirf Admin role ke liye business module check karo
//         if (role === 'Admin' && hospitalID && token) {
//             console.log('[Login] Admin user - checking business modules...');
            
//             // Step 4: Fetch business modules
//             const businessModules = await fetchBusinessModules(hospitalID, token);
            
//             // Step 5: Check for active plan
//             activePlan = checkActivePlan(businessModules, hospitalID);
            
//             // Step 6: Sync user subscription based on active plan
//             if (activePlan) {
//                 console.log('[Login] Active plan found, syncing to active...');
//                 await syncUserSubscription(userData, activePlan, token, dispatch);
//                 subscriptionStatus = 'active';
//                 subscriptionType = activePlan.businessType;
//             } else {
//                 console.log('[Login] No active plan found, syncing to inactive...');
//                 await syncUserSubscription(userData, null, token, dispatch);
//                 subscriptionStatus = 'inactive';
//                 subscriptionType = null;
//             }
//         } else {
//             console.log('[Login] Non-admin user, skipping subscription check');
//         }
        
//         // Step 7: Final data to save
//         const dataToSave = {
//             ...userData,
//             subscription_status: subscriptionStatus,
//             Subscription_type: subscriptionType,
//             app_status: userData.app_status || 'enabled',
//         };
        
//         localStorage.setItem('loginData', JSON.stringify(dataToSave));
//         console.log('[Login] Final loginData saved:', {
//             subscription_status: subscriptionStatus,
//             Subscription_type: subscriptionType
//         });
        
//         // Step 8: Dispatch LOGINAUTH
//         dispatch({
//             type: LOGINAUTH,
//             payload: {
//                 success: 1,
//                 data: dataToSave
//             }
//         });
        
//         return { success: true, data: loginData };
        
//     } catch (error) {
//         console.error('[Login] Error:', error);
//         return {
//             success: false,
//             message: error?.response?.data?.message || 'Incorrect Mobile or Password',
//         };
//     }
// };

// ============================================================
// UPDATE SUBSCRIPTION STATUS ACTION
// ============================================================
// loginAction.js - Updated handlelogin with captcha params and error handling

export const handlelogin = (mobile, password, captchaUuid, captchaInput) => async (dispatch) => {
    // ✅ Step 1: Payload updated with captcha params
    const loginObject = { 
        mobile, 
        password,
        captchaUuid,    
        captchaInput    
    };

    console.log("[Login] Sending payload:", loginObject);

    try {
        // Step 2: Login API Call
        const loginResponse = await axios.post(`${baseURL}/api/appointmentUser/login`, loginObject);
        const loginData = loginResponse.data;
        const userData = loginData.data;
        
        console.log('[Login] User logged in:', { role: userData.role, hospitalID: userData.hospitalID });
        
        // Step 3: Role Check - Sirf Admin ke liye subscription check (Original Logic)
        const token = userData.token;
        const hospitalID = userData.hospitalID;
        const role = userData.role;
        
        let activePlan = null;
        let subscriptionStatus = userData.subscription_status || 'inactive';
        let subscriptionType = userData.Subscription_type || null;
        
        // Sirf Admin role ke liye business module check karo
        if (role === 'Admin' && hospitalID && token) {
            console.log('[Login] Admin user - checking business modules...');
            
            // Fetch business modules
            const businessModules = await fetchBusinessModules(hospitalID, token);
            
            // Check for active plan
            activePlan = checkActivePlan(businessModules, hospitalID);
            
            // Sync user subscription based on active plan
            if (activePlan) {
                console.log('[Login] Active plan found, syncing to active...');
                await syncUserSubscription(userData, activePlan, token, dispatch);
                subscriptionStatus = 'active';
                subscriptionType = activePlan.businessType;
            } else {
                console.log('[Login] No active plan found, syncing to inactive...');
                await syncUserSubscription(userData, null, token, dispatch);
                subscriptionStatus = 'inactive';
                subscriptionType = null;
            }
        } else {
            console.log('[Login] Non-admin user, skipping subscription check');
        }
        
        // Step 4: Final data to save
        const dataToSave = {
            ...userData,
            subscription_status: subscriptionStatus,
            Subscription_type: subscriptionType,
            app_status: userData.app_status || 'enabled',
        };
        
        localStorage.setItem('loginData', JSON.stringify(dataToSave));
        console.log('[Login] Final loginData saved:', {
            subscription_status: subscriptionStatus,
            Subscription_type: subscriptionType
        });
        
        // Step 5: Dispatch LOGINAUTH
        dispatch({
            type: LOGINAUTH,
            payload: {
                success: 1,
                data: dataToSave
            }
        });
        
        return { success: true, data: loginData };
        
    } catch (error) {
        console.error('[Login] Error:', error);
        
        // ✅ Check if it's a captcha error (As per your new requirements)
        if (error?.response?.data?.message?.toLowerCase().includes('captcha')) {
            return {
                success: false,
                message: error.response.data.message || 'Invalid captcha. Please try again.',
            };
        }
        
        // Default error message
        return {
            success: false,
            message: error?.response?.data?.message || 'Incorrect Mobile or Password',
        };
    }
};
export const updateSubscriptionStatus = (subscriptionStatus, subscriptionType) => dispatch => {
    console.log('[updateSubscriptionStatus] Updating:', { subscriptionStatus, subscriptionType });

    const savedData = localStorage.getItem('loginData');
    if (savedData) {
        const loginData = JSON.parse(savedData);
        loginData.subscription_status = subscriptionStatus;
        loginData.Subscription_type = subscriptionType;
        localStorage.setItem('loginData', JSON.stringify(loginData));
        console.log('[updateSubscriptionStatus] localStorage updated');
    }

    dispatch({
        type: 'UPDATE_SUBSCRIPTION_STATUS',
        payload: {
            subscriptionStatus: subscriptionStatus,
            subscriptionType: subscriptionType,
        },
    });
};

// ============================================================
// OTHER ACTIONS (Same as before)
// ============================================================

export const userRegister = (userData) => async (dispatch) => {
    const config = {
        method: 'post',
        url: `${baseURL}/api/appointmentUser/create`,
        headers: { 'Content-Type': 'application/json' },
        data: userData,
    };

    try {
        const response = await axios(config);
        dispatch({ type: CREATEUSER, payload: response.data });
        return { success: 1, message: "Registration successful", data: response.data };
    } catch (error) {
        return { success: 0, message: error.response?.data?.message || "Registration failed." };
    }
};

export const updateUser = (userData) => async (dispatch) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.patch(
            `${baseURL}/api/appointmentUser/update`,
            userData,
            { headers: { 'Content-Type': 'application/json', Authorization: token ? `Bearer ${token}` : '' } }
        );

        if (response.data.success) {
            const currentLoginData = JSON.parse(localStorage.getItem('loginData') || '{}');
            if (currentLoginData.hospitalID === userData.hospitalID) {
                const updatedData = {
                    ...currentLoginData,
                    ...userData,
                    token: currentLoginData.token || token
                };
                localStorage.setItem('loginData', JSON.stringify(updatedData));
            }
            dispatch({ type: UPDATEUSER, payload: response.data });
        }

        return response.data;
    } catch (error) {
        console.error('Update user error:', error);
        throw error;
    }
};

export const updateUser1 = (UserData) => dispatch => {
    var config = {
        method: 'patch',
        url: baseURL + '/api/users/updatebymobail',
        headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
        data: UserData
    };
    axios(config)
        .then(response => dispatch({ type: UPDATEUSERBYMOBAIL, payload: response.data }))
        .catch(error => console.log(error));
};

export const resetPasswordByMobile = (mobile, newPassword) => async (dispatch) => {
    const updateData = { mobile, password: newPassword };
    const config = {
        method: 'patch',
        url: `${baseURL}/api/appointmentUser/update`,
        headers: { 'Content-Type': 'application/json' },
        data: updateData,
    };
    try {
        await axios(config);
        return { success: true, message: "Password updated successfully!" };
    } catch (error) {
        return { success: false, message: error.response?.data?.message || "Failed to update password" };
    }
};

export const getUserById = async (HospitalId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${baseURL}/api/appointmentUser/byid`,
            { hospitalID: HospitalId },
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) return response.data.data.subscription_status;
        return null;
    } catch (error) {
        return null;
    }
};

export const getAllUsers = (hospitalID) => (dispatch) => {
    const token = localStorage.getItem('token');
    const config = {
        method: 'post',
        url: `${baseURL}/api/appointmentUser/getall`,
        headers: { 'Content-Type': 'application/json', ...(token && { 'Authorization': `Bearer ${token}` }) },
        data: { hospitalID },
    };
    return axios(config)
        .then(response => dispatch({ type: GET_ALL_USERS, payload: response.data }))
        .catch(error => console.error("Fetching users failed:", error.response?.data || error.message));
};

export const getUserbyroll = (UserData) => dispatch => {
    var config = {
        method: 'post',
        url: baseURL + '/api/users/getallbyroll',
        headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
        data: UserData
    };
    axios(config)
        .then(response => dispatch({ type: GETUSERBYROLL, payload: response.data }))
        .catch(error => console.log(error));
};

export const deleteUser = (data) => (dispatch) => {
    var config = {
        method: "delete",
        url: baseURL + "/api/users/delete",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" },
        data: data,
    };
    axios(config)
        .then(response => dispatch({ type: DELETEUSER, payload: response.data }))
        .catch(error => console.log(error));
};

export const logout = () => (dispatch) => {
    console.log('[Logout] Clearing all data...');
    localStorage.removeItem('loginData');
    localStorage.removeItem('token');
    localStorage.removeItem('hospitalCode');
    localStorage.removeItem('redirectAfterLogin');
    localStorage.removeItem('StaffRole');
    localStorage.removeItem('selectedCurrency');

    dispatch({ type: 'LOGOUT' });
    window.location.href = '/#/';
};

export const handleClearState = () => (dispatch) => {
    dispatch({ type: LOGINULL, payload: 0 });
};